import { PopUp, Row } from '../../../../components/Basic/Blocks';
import { Button } from '../../../../components/Basic/Buttons';
import { H2 } from '../../../../components/Basic/WrapsStyle';
import { TYPE_BUTTONS } from '../../../../constans';
import styles from './styles.module.scss';

const IP_LIST = [
  { name: 'Макаров А.Н.', value: 2 },
  { name: 'Макаров Н.Н.', value: 1 },
  { name: 'Макаров А.С.', value: 3 },
  { name: 'Гудилина И.А.', value: 5 },
  { name: 'Гудилина Д.О.', value: 7 },
  { name: 'Кравец С.П.', value: 4 },
  { name: 'Кравец Т.С.', value: 6 },
];

const RebuyPopUp = ({ providers, alts, order, product, onChangeOrderData = () => { }, onChange = () => { }, close = () => { } }) => {


  return (
    <PopUp style={{ width: 'auto' }} close={close} clickOutside={false} className={styles.pop_up}>
      <H2>{`Перекуп "${product.name}" от ${providers.find(P => P.id === product.provider_id)?.name} ${order.market.toUpperCase()}`}</H2>

      <div style={{ marginTop: '10px' }}>{`Заказов: ${product.ordered_quantity} шт. / В заказе: ${product.quantity} шт.`}</div>
      <div style={{ marginTop: '5px' }}>{`Цена: ${product.price} / Коммиссия: ${+product.commission.common.rub.toFixed(2)} / Отмена: ${-(product.price / 2).toFixed(2)} `
      }</div>
      {/* / Прибыль: ${newOrder.purchase ? +(product.price - product.commission.common.rub - (newOrder.purchase * product.quantity)).toFixed(2) : ''} */}


      {/* <Row> */}
      {/* <div>
            {`Замены`}
          </div> */}
      {alts?.length > 0 ?

        <div style={{ width: '100%', marginTop: '30px' }} >
          <table style={{ width: '100%' }} className={styles.table_stat}>
            <thead>
              <th>Поставщик</th>
              <th>Артикул</th>
              <th>Наименование</th>
              <th >МСК</th>
              <th >ЕКБ</th>
              <th>Цена</th>
              <th>Прибыль</th>
            </thead>
            <tbody>
              {alts.map(p => {
                return (<tr key={p.artnumber}>
                  <td>{providers.find(P => P.id === p.provider_id)?.name}</td>
                  <td
                  >{p.artnumber}</td>
                  <td>
                    {p.url ? (<a href={p.url} target="_blank" style={{ color: '#000355e8' }} rel="noreferrer">{p.name}</a>) : (p.name)}
                  </td>
                  <td>{p.stocks.msk}</td>
                  <td>{p.stocks.ekb}</td>
                  <td>{p.purchase}</td>
                  <td>{+(product.price - product.commission.common.rub - (p.purchase * product.quantity)).toFixed(2)}</td>
                </tr>)
              })}
            </tbody>
          </table>
        </div>
        : <></>}

      <Row style={{ marginTop: '50px' }}>

        <Button type={TYPE_BUTTONS.GREY} onClick={close}>
          Отменить
        </Button>
      </Row>
    </PopUp >
  );
};

export default RebuyPopUp;
